export default __webpack_public_path__ + "static/media/c2.416a6718.jpg";